/**
 * Pretty-prints a JSON string with two-space indentation. Values that do not
 * parse are returned unchanged, because the source (a log or audit payload) is
 * only expected to be JSON, never guaranteed to be.
 * @registry Canonical pretty-printer for stored JSON strings; returns the raw text when it does not parse and '' when absent.
 */
export const formatJsonString = (raw: string | null | undefined): string => {
  if (!raw) return '';
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
};
